import React from 'react';
import { Link } from 'react-router-dom';

export default function UserLoginBtn() {
	return (
		<div className="user-login-btn">
			<Link to="/login" className="btn btn--sm btn--secondary--outline">ورود / عضویت
				<span className="icon icon-dr-black-arrow-left"></span>
			</Link>
		</div>
	)
}
